export const apiUrl = {
  getCountries: "https://disease.sh/v3/covid-19/countries",
  getAllCases: "https://disease.sh/v3/covid-19/all",
  getCasesByCountry: "https://disease.sh/v3/covid-19/countries/",
  getAllHistoricalData:
    "https://disease.sh/v3/covid-19/historical/all?lastdays=120",
};
